/**
 * Created with JetBrains PhpStorm.
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 * To change this template use File | Settings | File Templates.
 *
 * NOTE!!!
 * creator.id === creator.get('cid');
 * creator.cid !== ceator.get('cid');
 *
 * Requires :
 * SoaModel
 * dibs.endpoints
 * ItemCreator
 * ItemCreators
 *
 */
'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var _ = require('underscore');
var Creator = module.exports = SoaModel.extend();
var endpoints = require('dibs-endpoints');
var ItemCreator = require('bunsen/models/link-models/ItemCreator');
var ItemCreators = require('bunsen/collections/inventory/ItemCreators');
var Backbone = require('dibs-backbone');

_.extend(Creator.prototype, {
    url: function () {
        return this.isNew() ? endpoints.creator() : endpoints.creator() + '/' + this.get('id');
    },
    idAttribute: 'id',
    defaults: {
        pageExists: 'N',
        sortName: ''
    },
    relations: [{
            type: Backbone.HasMany || Backbone.One,
            key: 'items',
            relatedModel: ItemCreator,
            collectionType: ItemCreators,
            reverseRelation: {
                includeInJSON: 'id'
            }
        }]
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Creator.js
// module id = 2637
// module chunks = 62